export class Click {
    from:string;
    href:string;
    insertedTime:string;
    total:number;
}
